import React from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import "./style.css";
import { images } from "../../../constants/index";
import Walletsidebar from "../../../components/Wallet_sidebar";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
const opportunities = [
  {
    title: "Renewable Energy Project",
    image: images.livechat16,
  },
  {
    title: "Tech Startup Fund",
    image: images.livechat16,
  },
  {
    title: "Sustainable Agriculture Initiative",
    image: images.livechat16,
  },
  {
    title: "Real Estate Development",
    image: images.livechat16,
  },
  {
    title: "Water Conservation Program",
    image: images.livechat16,
  },
  {
    title: "Healthcare Innovation Fund",
    image: images.livechat16,
  },
  {
    title: "Education Support System",
    image: images.livechat16,
  },
];

const InvestmentSearch = () => {
  const navigate = useNavigate();

  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");

  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");

  // Function to handle the country selection
  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };

  // Function to handle the state selection
  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  // Function to handle the city selection
  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };
  const [countrydata, SetCountrydata] = useState([]);
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);

  useEffect(() => {
    axios
      .get(
        "https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json"
      )
      .then((res) => SetCountrydata(res.data))

      .catch((error) => {});
  }, []);

  const country = [...new Set(countrydata.map((item) => item.country))];

  country.sort();
  const handleCountry = (e) => {
    let states = countrydata.filter(
      (state) => state.country === e.target.value
    );
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter(
      (city) => city.subcountry === e.target.value
    );
    setGetcity(cities);
  };

  return (
    <Row>
      <div className="screenHeight d-lg-flex justify-content-around align-items-center p-3">
        <Col
           lg="2"
          md="12"
          sm="12"
          xs="12"
          className="bg-white shadow-sm side---bar-h  rounded"
          style={{ border: "1px solid #0353a4" }}
        >
          <Walletsidebar />
        </Col>

        <Col lg="3"md="12" sm="12" xs="12" className="filter-column h-lg-100">
          <Card className="filter-card">
            <Card.Header className="filter-header">
              <strong>Search Category, Area & Desired Location</strong>
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Group controlId="projectName" className="mb-1">
                  <Form.Label>Search by Project Name</Form.Label>
                  <Form.Control type="text" placeholder="Project name" />
                </Form.Group>

                <Form.Group controlId="projectDuration" className="mb-1">
                  <Form.Label>Project Duration</Form.Label>
                  <Form.Select>
                    <option>Select</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="projectType" className="mb-1">
                  <Form.Label>Project Type</Form.Label>
                  <Form.Select>
                    <option>Select</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="industryCategory" className="mb-1">
                  <Form.Label>Industry or Category</Form.Label>
                  <Form.Select>
                    <option>Select</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="projectName" className="mb-3 ">
                  <Form.Label>Minimum Investment Amount</Form.Label>
                  <Form.Control type="number" placeholder="Amount" />
                </Form.Group>

                <Form.Group controlId="country" className="mb-1">
                  <Form.Label>Country</Form.Label>
                  <Form.Select onChange={(e) => handleCountry(e)}>
                    <option disabled selected>
                      Select Country
                    </option>
                    {country.map((country, index) => (
                      <option key={country} value={getcountry}>
                        {country}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="state" className="mb-1">
                  <Form.Label>State</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      handleState(e);
                      handleCountryChangestate(e);
                    }}
                  >
                    <option selected disabled>
                      Select State
                    </option>

                    {getState.map((country) => (
                      <option key={country} value={selectedState}>
                        {country}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="city" className="mb-4">
                  <Form.Label>City</Form.Label>
                  <Form.Select onChange={(e) => handleCountryChangecity(e)}>
                    <option selected disabled>
                      Select City
                    </option>
                    {getcity.map((country) => (
                      <option key={country.name}>{country.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  Search
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col lg="6"  md="12" sm="12" xs="12"  className="h-lg-100 investment-section">
          {/* Banner */}
          <div className="banner-container mb-4">
            <img
              src={images.p3}
              alt="Banner"
              className="img-fluid rounded shadow"
            />
          </div>

          {/* Title */}
          <h5 className="section-title mb-3">
            Explore Investment Opportunities
          </h5>

          {/* Scrollable card area */}
          <div className="scrollable-card-container">
            <Row>
              {opportunities.map((item, index) => (
                <Col xs={12} sm={6} md={6} lg={4} xl={4} key={index} className="mb-4">
                  <Card className="opportunity-card h-100 shadow-sm">
                    <Card.Img variant="top" src={item.image} />
                    <Card.Body className="d-flex flex-column p-3">
                      <Card.Title className="font_13">{item.title}</Card.Title>
                      <div className="mt-auto d-flex justify-content-between">
                        <Button
                          variant="primary"
                          className="pt-1  pb-1 ps-xl-4 pe-xl-4 font_12 text-white"
                          onClick={() => navigate("/project-details")}
                        >
                          View
                        </Button>
                        <Button
                          variant="outline-primary"
                          className="pt-1 pb-1 p-2 font_12"
                        >
                          Connect
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </div>
    </Row>
  );
};

export default InvestmentSearch;
